import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        maxWidth: 380,
        textAlign: "center",
        color: theme.palette.grey[700],
    },
    icon: {
        height: 80,
        width: 80,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(244, 67, 54, 0.12)",
        borderRadius: "50%",
        marginBottom: 12,
        "& svg": {
            height: 48,
            width: 48,
            color: "rgba(244, 67, 54)",
        },
    },
}));
